import React from 'react';
import { ImageButtonStyled } from './styled';
export function ImageButton({ onClick, children, width, height, }) {
    if (children) {
        return (React.createElement(ImageButtonStyled, { onClick: onClick, type: "button", role: "button", width: width, height: height }, children));
    }
    return null;
}
ImageButton.displayName = 'ImageButton_Component';
